import type { Tutorial } from '../types'

const IMG = '/images/tutorials/web/wellness-coach'

export const wellnessCoachWebTutorial: Tutorial = {
  slug: 'wellness-coach',
  platform: 'web',
  title: 'Wellness Coach',
  subtitle: 'Your coach in the browser — grounded in your health data',
  date: '2026-07-09',
  category: 'Core Features',
  tags: ['Wellness Coach', 'genetics', 'coaching'],
  description:
    'Open Coach from the dashboard sidebar to get help that knows your records, genetics and goals — with every past conversation kept in one list and safety checks built in.',
  highlights: [
    'Lives at /chat with full dashboard context and profile switching.',
    'Ask anything, or pick a starter: the Coach reads your records and goals first.',
    'Past coaching sessions sit in your Topics list, read-only, with a button to carry on in a new conversation.',
  ],
  coverImage: `${IMG}/01-coaching-home.png`,
  sections: [
    {
      heading: 'The Coach workspace',
      paragraphs: [
        'Coach opens inside the main Livewello dashboard — the profile switcher and your Topics list are one click away. Start a conversation and the Coach draws on your active profile\'s genetics, health records, and goals.',
      ],
      image: {
        src: `${IMG}/01-coaching-home.png`,
        alt: 'Coach workspace in the Livewello web dashboard',
        caption: 'Coach home',
      },
    },
  ],
  whyMatters:
    'On web, the Coach sits alongside your records and goals instead of in a separate tab. That means longer conversations, easier copy-paste from lab results, and a full keyboard for detailed check-ins — while the Coach still reads the same genetics and health data as on mobile.',
  nextSlug: 'wellness-goals',
  relatedSlugs: ['wellness-goals', 'health-records'],
  meta: {
    description: 'Wellness Coach on Livewello web: one coach with genetics and health-record context.',
    ogImage: `${IMG}/01-coaching-home.png`,
  },
}
